// TODO IMPROVEMENT: Modify backend response for camelCase

import { SurtitleTagType } from 'src/app/content-management/shared/enums/surtitle-tag-type';

export interface ISurtitle {
  id: string;
  name: string;
  displayText: string;
  surtitleType: SurtitleTagType;
}
export class Surtitle implements ISurtitle {
  constructor(
    public id: string,
    public name: string,
    public displayText: string,
    public surtitleType: SurtitleTagType
  ) {}
}
